export const DatePickerTestIdFactory = {
    getDatePickerBase: () => 'date-picker',
    getDatePickerLabelBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'label'].join('-'),
    getDatePickerInputLabelTestId: (testId) => [DatePickerTestIdFactory.getDatePickerLabelBase(), testId].join('-'),
    getDatePickerHeaderBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'header'].join('-'),
    getDatePickerDescriptionBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'description'].join('-'),
    getDatePickerDescriptionTestId: (testId) => [DatePickerTestIdFactory.getDatePickerDescriptionBase(), testId].join('-'),
    getDatePickerDialogBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'dialog'].join('-'),
    getDatePickerDialogTestId: (testId) => [DatePickerTestIdFactory.getDatePickerDialogBase(), testId].join('-'),
    getDatePickerCalendarBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'calendar'].join('-'),
    getDatePickerCalendarTestId: (testId) => [DatePickerTestIdFactory.getDatePickerCalendarBase(), testId].join('-'),
    getDatePickerHeaderMonthAndYearTestId: (testId) => [DatePickerTestIdFactory.getDatePickerHeaderBase(), testId].join('-'),
    getDatePickerDayBase: () => [DatePickerTestIdFactory.getDatePickerBase(), 'day'].join('-'),
    getDatePickerDayTestId: (dateStamp, testId) => [
        DatePickerTestIdFactory.getDatePickerDayBase(),
        dateStamp,
        testId,
    ].join('-'),
    getDatePickerPrevMonthButton: (testId) => [
        DatePickerTestIdFactory.getDatePickerBase(),
        'prev-month',
        testId,
    ].join('-'),
    getDatePickerNextMonthButton: (testId) => [
        DatePickerTestIdFactory.getDatePickerBase(),
        'next-month',
        testId,
    ].join('-'),
};
